/*

FILE: videoAlt.js
DESCRIPTION: Vimeo embeds
AUTHOR(S): R.J. LaCount

*/

import Player from '@vimeo/player';

const initVideoAlt = (els) => {
    
    els.forEach(el => {
    
        const url = el.dataset.inlineVideo;
        const videoContainer = el.querySelector('.video-container');
        const video = new Player(videoContainer);
    
        el.addEventListener('click', () => {
            el.querySelector('img').classList.add('hidden');
            video.play();
        });
    
    });

}

export { initVideoAlt }
